<template>
  <div v-if="initialized" :class="isPrint ? 'container' : (isLogin ? 'login container-fluid' : 'container-fluid')">
    <div id="app">
      <app-header v-if="loggedIn && !isPrint"></app-header>
      <app-menu v-if="loggedIn"></app-menu>
      <app-chat v-if="loggedIn"></app-chat>
      <router-view/>
    </div>

    <b-modal centered v-model="alertshown" class="alertbox" ref="modalalert" id="modalalert" v-bind:hide-footer="true" v-bind:hide-header="true">
      <div class="row">
        <div class="col-12 center">
          <p>{{modaltext}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-6 text-right">
          <a v-on:click.prevent="negativeModalFunc" class="btn btn-third">{{$t('NO')}}</a>
        </div>
        <div class="col-6 text-left">
          <a class="btn btn-primary" v-on:click.prevent="positiveModalFunc">{{$t('YES')}}</a>
        </div>
      </div>
    </b-modal>

  </div>
  <div v-else-if="!initialized" class="loading-page">
    <icon name="spinner" scale="2" spin></icon>
  </div>

</template>

<script>
import Header from '@/components/Header.vue'
import Menu from '@/components/Menu.vue'
import Chat from '@/components/Chat.vue'
import
{
    mapGetters,
    mapActions
}
from 'vuex'
import globals from '@/api/globals'

export default
{
    name: 'app',
    data: function()
    {
        return {
            alertshown: false,
            positivefunc: function() {},
            modaltext: '',
            negativefunc: function() {}
        }
    },
    components:
    {
        'app-header': Header,
        'app-menu': Menu,
        'app-chat': Chat
    },
    methods:
    {
        ...mapActions([
            'getGlobals',
            'fetchLanguage',
            'selectMyMessageCount',
            'selectMyTasksCount',
            'selectMyNotificationsCount'
        ]),
        positiveModalFunc: function()
        {
            var me = this;
            me.positivefunc();
            me.alertshown = false;
            me.positivefunc = function() {};
        },
        negativeModalFunc: function()
        {
            var me = this;
            me.negativefunc();
            me.alertshown = false;
            me.negativefunc = function() {};
        }
    },
    created: function()
    {
        var me = this;
        me.getGlobals();
        me.selectMyMessageCount();
        me.selectMyTasksCount();
        me.selectMyNotificationsCount();

        setInterval(function()
        {
            me.selectMyMessageCount();
            me.selectMyTasksCount();
            me.selectMyNotificationsCount();
        }, 5000);
    },
    watch:
    {
        'globals.auth': function(value)
        {
            var me = this;
            me.fetchLanguage(me.globals.langCode);
            if ((value == 0 || value == 2) && this.$route.path.indexOf('/login') == -1)
            {
                this.$router.push('/login')
            }
            else if (this.$route.path.indexOf('/login') !== -1 && (value == 9 || value == 10))
            {
                this.$router.push('/dentalsolutions')
            }
            else if (this.$route.path.indexOf('/login') !== -1)
            {
                this.$router.push('/patients')
            }
            else if (this.$route.path == '/')
            {
                if (value == 9 || value == 10)
                {
                    this.$router.push('/dentalsolutions')
                }
                else
                {
                    this.$router.push('/patients')
                }
            }
        },
        translation: function(value)
        {
            var me = this;
            me.$i18n.setLocaleMessage(me.globals.langCode, value)
            me.$i18n.locale = me.globals.langCode
        },
        langInitialized: function(value)
        {
            if (value)
            {
                this.$i18n.missing = function(handler, key, vueInst)
                {
                    // globals.checkTrans(key)
                }
            }
        },
        modalAlert: function(val)
        {
            var me = this;
            me.alertshown = true;
            me.modaltext = val.text;
            me.positivefunc = val.btnAction;
            if (typeof val.btnNo != 'undefined')
            {
                me.negativefunc = val.btnNo;
            }
        }
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'modalAlert',
            'translation',
            'langInitialized'
        ]),
        loggedIn: function()
        {
            return (this.globals.auth != 2) ? true : false;
        },
        initialized: function()
        {
            return (this.globals.auth != 0) ? true : false;
        },
        isLogin()
        {
            return (this.$route.path.indexOf('/login') != -1);
        },
        isPrint()
        {
            return (this.$route.path.indexOf('/printworkorder') != -1 || this.$route.path.indexOf('/printdsdailyreport') != -1 || this.$route.path.indexOf('/printdsmonthlyreport') != -1 || this.$route.path.indexOf('/printdsclientreport') != -1);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue